import { PageIntro } from "./ui";

export function ImpressumPage() {
  return (
    <>
      <PageIntro eyebrow="Legal notice" title={<>Impressum.</>}>
        Provider information for Proxima Forma.
      </PageIntro>
      <article className="mk-prose mk-container mk-data-page">
        <h2>Service provider</h2>
        <p>
          Proxima Forma at https://proximaforma.com is operated by RatioSky LTD,
          registered in England and Wales under company number 15779851.
        </p>
        <p>
          Registered office: 71–75 Shelton Street, Covent Garden, London,
          United Kingdom, WC2H 9JQ.
        </p>
        <h2>Contact</h2>
        <p>
          Email: <a href="mailto:support@proximaforma.com">support@proximaforma.com</a>
        </p>
      </article>
    </>
  );
}
